import { round, toFloat } from './numbers';

export function percentToTaxMultiplier(tax) {
  return toFloat(tax) / 100;
}

export function priceWithoutTaxes(priceWithTaxes, tax, exact = false) {
  const result = toFloat(priceWithTaxes) / (1 + percentToTaxMultiplier(tax));
  return (exact) ? result : round(result);
}

export function priceWithTaxes(priceWithoutTaxes, tax, exact = false) {
  const result = toFloat(priceWithoutTaxes) * (1 + percentToTaxMultiplier(tax));
  return (exact) ? result : round(result);
}

export function taxesFromTaxlessPrice(priceWithoutTaxes, tax) {
  return round(priceWithTaxes(priceWithoutTaxes, tax, false) - toFloat(priceWithoutTaxes));
}

export function taxesFromPriceWithTaxes(priceWithTaxes, tax) {
  return round(toFloat(priceWithTaxes) - priceWithoutTaxes(priceWithTaxes, tax, false));
}
